import React from 'react';

const RankingsTitle = ({
  children,
}) => (
  <div className="rounded-pill bg-light row no-gutters align-items-center">
    <div className="col-auto">
      <img
        src="/assets/img/cup.svg"
        style={{ width: '35px' }}
      />
    </div>
    <div className="col text-center">
      {children}
    </div>
    <div className="col-auto">
      <img
        src="/assets/img/cup.svg"
        style={{ width: '35px' }}
      />
    </div>
  </div>
);

export default RankingsTitle;
